import { Modal, Form, Input, message } from "antd";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { actions } from "../slice";
import { ImageUpload } from "../../../../../components/Backoffice/ImageUpload";
import { useEffect } from "react";

export default function ChangeBoxStatus({
  visible,
  onClose,
  boxData,
  targetStatus,
  fetchKitDetail,
}) {
  const dispatch = useDispatch();
  const { control, handleSubmit, reset, watch, setValue } = useForm({
    defaultValues: {
      packedImages: [],
      dispatchImages: [],
      trackingCode: "",
    },
  });

  const trackingCode = watch("trackingCode");

  useEffect(() => {
    if (!visible) {
      reset({
        packedImages: [],
        dispatchImages: [],
        trackingCode: "",
      });
    }
  }, [visible, reset]);

  const handleClose = () => {
    reset({
      packedImages: [],
      dispatchImages: [],
      trackingCode: "",
    });
    onClose();
  };

  const onSubmit = (data) => {
    
    // Validate required fields based on status
    if (targetStatus === "packed") {
      if (!data.packedImages || data.packedImages.length === 0) {
        message.error("Please upload at least one packed image");
        return;
      }
    }

    if (targetStatus === "dispatched") {
      if (!data.dispatchImages || data.dispatchImages.length === 0) {
        message.error("Please upload at least one dispatch image");
        return;
      }
      if (!data.trackingCode || data.trackingCode.trim() === "") {
        message.error("Please enter a tracking code");
        return;
      }
    }

    // Prepare payload
    const payload = {
      samplerBoxId: boxData._id,
      status: targetStatus,
    };

    if (targetStatus === "packed") {
      payload.packedImages = data.packedImages.map(img => img.url);
    }

    if (targetStatus === "dispatched") {
      payload.dispatchImages = data.dispatchImages.map(img => img.url);
      payload.trackingCode = data.trackingCode.trim();
    }


    dispatch(
      actions.changeBoxStatus({
        postData: payload,
        onSuccess: (response) => {
          message.success(
            `Box status changed to ${targetStatus} successfully`
          );
          fetchKitDetail(false);
          handleClose();
        },
        onFailure: (error) => {
          message.error(
            error?.message || `Failed to change box status to ${targetStatus}`
          );
        },
      })
    );
  };

  const getModalTitle = () => {
    return targetStatus === "packed" 
      ? "Move to Packed" 
      : "Move to Dispatch";
  };

  if (!visible) return null;

  return (
    <Modal
      title={getModalTitle()}
      visible={visible}
      onCancel={handleClose}
      onOk={handleSubmit(onSubmit)}
      okText="Submit"
      cancelText="Cancel"
      width={600}
      destroyOnClose
    >
      <Form layout="vertical" style={{ marginTop: 20 }}>
        {targetStatus === "packed" && (
          <ImageUpload
            name="packedImages"
            control={control}
            label="Packed Images *"
            maxCount={5}
            acceptType={["image/*"]}
            required
            fullLabelWidth
          />
        )}

        {targetStatus === "dispatched" && (
          <>
            <ImageUpload
              name="dispatchImages"
              control={control}
              label="Dispatch Images *"
              maxCount={5}
              acceptType={["image/*"]}
              required
              fullLabelWidth
            />
            <Form.Item
              label="Tracking Code"
              required
              style={{ marginTop: 16 }}
            >
              <Controller
                name="trackingCode"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    placeholder="Enter tracking code"
                  />
                )}
              />
            </Form.Item>
          </>
        )}

        <div style={{ 
          padding: "12px", 
          background: "#f0f2f5", 
          borderRadius: "8px",
          marginTop: "16px"
        }}>
          <p style={{ margin: 0, fontSize: "14px", color: "#595959" }}>
            <strong>Box ID:</strong> {boxData?.boxId}
          </p>
          <p style={{ margin: "8px 0 0 0", fontSize: "14px", color: "#595959" }}>
            <strong>Current Status:</strong> {boxData?.status}
          </p>
        </div>
      </Form>
    </Modal>
  );
}